<template>
  <chartjs-bar-card :chartData="chartData" :chartOptions="chartOptions">
    <template slot="header">
      <div class="d-flex">
        <div class="card-title diligencePieChartTitle">{{ title }}</div>
        <!-- <div
          style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
          v-tooltip.top-end="toolTipInfo"
        >
          <img src="static/img/graphInfo.svg" class />
        </div> -->
      </div>
    </template>
  </chartjs-bar-card>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsBarCard } from "src/components/index";
import { mapGetters } from "vuex";
import _ from "lodash";
import ChartjsBar from "../../Chartjs/ChartjsBar";
export default {
  name: "bar-lp-chart-card",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsBarCard,
    ChartjsBar,
  },
  computed: {
    ...mapGetters("charts", ["portfolioROIByProperty"]),
    ...mapGetters("user", ["currency"]),
    chartData() {
      const self = this;
      let portfolioInfo = self.portfolioROIByProperty(self.property);
      let labels = portfolioInfo[self.property];
      //   labels = _.map(labels, (lbl) => {
      //     return lbl.length > 12 ? _.truncate(lbl, { length: 12 }) : lbl;
      //   });
      let data = {
        labels,
        datasets: [
          {
            label: "Cost",
            labels_unadultered: portfolioInfo[self.property],
            data: portfolioInfo.cost,
            backgroundColor: "#006BFD",
          },
          {
            label: "Value",
            labels_unadultered: portfolioInfo[self.property],
            data: portfolioInfo.value,
            backgroundColor: "#2EB7FF",
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            title: function (toolTips, data) {
              let toolTipItem = toolTips[0];
              return data.datasets[toolTipItem.datasetIndex].labels_unadultered[
                toolTipItem.index
              ];
            },
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": " +
                formatCurrency(
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ] || 0,
                  self.currency.ref,
                  0,
                  true
                )
              );
            },
          },
        },
        legend: {
          position: "top",
          align: "end",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return formatCurrency(value, self.currency.ref, 0);
                },
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      const self = this;
      return "";
    },
  },
  data() {
    return {
      category: {
        selected: "sector",
        title: "Sector",
      },
      categoryDropDownSelected: {
        selected: "sector",
        title: "ROI By Sector",
      },
      subCategoryDropDownSelected: {
        selected: "all",
      },
    };
  },
  props: {
    defaultSelected: {
      type: String,
      default() {
        return undefined;
      },
    },
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows a comparison of value and cost in the same category.`;
      },
    },
    title: String,
    property: String,
  },
  mounted() {},
  methods: {},
};
</script>
<style>
</style>